import { Box, Container, styled } from '@mui/material';
import { palette } from 'assets/styles/colors';
import { theme } from 'assets/themes/zizzi';
import SingleAccordion from 'components/SingleAccordion';
import Markdown from 'components/Markdown';

export const StyledContainer = styled(Container)`
  li {
    padding-left: 0;
  }

  &.MuiContainer-root {
    padding: 2rem 0;

    > .Mui-expanded.MuiPaper-root {
      margin-bottom: 1rem;
    }
  }

  ${theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding: 6rem 10rem;
    }
  }

  .MuiAccordion-root {
    .MuiAccordionSummary-content {
      margin: 0;
      padding: 1rem 0;
    }

    .MuiAccordionDetails-root {
      padding: 0 1rem;

      .MuiPaper-root {
        margin-top: 1rem;
      }
    }

    p,
    a {
      margin-top: 0;
      color: ${palette.neutral[600]};
    }
  }
`;

export const StyledSingleAccordion = styled(SingleAccordion)`
  &.MuiAccordion-root {
    border: none;

    ::before {
      background-color: transparent;
    }

    & > .MuiAccordionSummary-root {
      border-bottom: 2px solid rgba(0, 0, 0, 0.12);
      border-radius: 0;

      .MuiAccordionSummary-content {
        .MuiTypography-root {
          font-family: 'Zizzi';
        }
      }
    }

    .MuiAccordionSummary-root:hover {
      background-color: transparent;
    }
  }
`;

export const Section = styled(Box)`
  margin-bottom: 60px;

  ${theme.breakpoints.down('sm')} {
    padding: 0 1rem;
    margin-bottom: 40px;
  }
`;

export const StyledMarkdown = styled(Markdown)`
  img[src$='#MoreIcon'] {
    margin: 0 -5px -7px;
  }

  img[src$='#IosShareIcon'] {
    margin: 0 0 -4px;
  }
`;
